import React from 'react';

import { ModalBody } from 'ui-components/components/modal/modal-body';

import { ErrorBanner } from './edit-tax-identifiers-error-banner';
import { EditRecipientTaxIdentifiersInstructions } from './edit-tax-identifiers-instructions';

import style from './styles.module.less';
import { EditRecipientTaxIdentifiersForm } from './edit-tax-identifiers-form';

const EditRecipientTaxIdentifiersBody = () => (
  <ModalBody className={style['edit-content']}>
    <ErrorBanner />
    <EditRecipientTaxIdentifiersInstructions />

    <EditRecipientTaxIdentifiersForm />
  </ModalBody>
);

export { EditRecipientTaxIdentifiersBody };
